import React, { useCallback, useState } from "react";
import accInstance from "./base/acc";

const PostHookAccount = () => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();

  const callApi = useCallback(async (pro) => {
    setLoading(true);
    try {
      const res = await accInstance.post(pro.url, pro.body);
      setData(res);
      return res;
    } catch (err) {
      setData(err);
      console.log("err", err);
      // errorToast(err.response.data.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return [isLoading, data, callApi];
};

export default PostHookAccount;
